module.exports = __webpack_public_path__ + "r-v3/img/mic_off_gray.70743464.svg";